
        <div class="form-body">
            <h3 class="card-title">Crear o modificar preguntas</h3>
            <hr>
            <div class="row p-t-20">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">Escala</label>
                        <select id="scaleSelector" (change)="changeType($event.target.value)" class="form-control custom-select">
                            <option value="validez">Validez</option>
                            <option value="clinicas">Clínicas</option>
                            <option value="lingoes">Harris-Lingoes</option>
                            <option value="contenido">Contenido</option>
                            <option value="suplementarias">Suplementarias</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label">Subescala<span *ngIf="loadingScales"><img width="20" src="assets/images/loading.gif" alt=""> Cargando...</span></label>
                        <select *ngIf="scales.length>0" class="form-control" (change)="selectSubscale()" [(ngModel)]="selectedScale">
                            <option disabled value="">Seleccione subescala</option>
                            <option *ngFor="let v of scales" [value]="v.scale">{{v.scale=='Mf'?'Mf-v':v.scale=='MfM'?'Mf-m':v.scale}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row p-t-20">
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">Texto</label>
                        <input [(ngModel)]="text" [ngModelOptions]="{standalone:true}" type="text"  class="form-control" placeholder="Texto">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">Índice</label>
                        <input type="number" [(ngModel)]="index" class="form-control">
                    </div>
                </div>
            </div>
            <button *ngIf="!isEditing" (click)="addQuestion()" class="btn btn-rounded waves-effect btn-primary m-b-20">Agregar pregunta</button>
            <button *ngIf="isEditing" (click)="reload()" class="btn btn-rounded waves-effect btn-warning m-b-20">Cancelar</button>
            <button *ngIf="isEditing" (click)="updateQuestion()" class="btn btn-rounded waves-effect btn-primary m-b-20">Actualizar pregunta</button>
            <div *ngIf="selectedScale">
                <div class="row" *ngIf="selectedScale!='VRIN'&&selectedScale!='TRIN'">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="control-label">Índice de correlación</label>
                            <input type="number" id="index" [(ngModel)]="valueIndex" class="form-control" min="1">
                        </div>
                    </div>
                    <button (click)="addTrue()" class="btn btn-rounded waves-effect btn-success m-b-20">Agregar a verdaderos</button>
                    <button (click)="addFalse()" class="btn btn-rounded waves-effect btn-warning m-b-20">Agregar a falsos</button>
                    <div class="col-md-12">
                        <h5>Verdaderos</h5>
                        <div class="row">
                            <div *ngFor="let it of trueItems; index as i" class="col-3 m-b-10">
                                <b ><a href="javascript:void(0)" (click)="restoreItem(i,it,true)">{{it+1}}</a></b>
                            </div>
                        </div>
                        <h5>Falsos</h5>
                        <div class="row">
                            <div *ngFor="let it of falseItems; index as i" class="col-3 m-b-10">
                                <b ><a href="javascript:void(0)" (click)="restoreItem(i,it,false)">{{it+1}}</a></b>
                            </div>
                        </div>
                    </div>
                    <button (click)="setCorrelations()" class="btn btn-rounded waves-effect btn-primary m-b-20">Actualizar correlaciones</button><span *ngIf="loadingScales"><img width="20" src="assets/images/loading.gif" alt=""> Guardando...</span>
                </div>
                <div class="row" *ngIf="selectedScale=='VRIN'||selectedScale=='TRIN'">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">Índice 1</label>
                            <input type="number" [(ngModel)]="dualForm.index1" class="form-control" min="1">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">Valor</label>
                            <select [(ngModel)]="dualForm.value1" [ngModelOptions]="{standalone:true}" class="form-control" placeholder="Valor">
                                <option [ngValue]="true">Verdadero</option>
                                <option [ngValue]="false">Falso</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">Índice 2</label>
                            <input type="number" [(ngModel)]="dualForm.index2" class="form-control" min="1">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="control-label">Valor</label>
                            <select [(ngModel)]="dualForm.value2" [ngModelOptions]="{standalone:true}" class="form-control" placeholder="Valor">
                                <option [ngValue]="true">Verdadero</option>
                                <option [ngValue]="false">Falso</option>
                            </select>
                        </div>
                    </div>
                    <button (click)="addDual()" class="btn btn-rounded waves-effect btn-success m-b-20">Agregar dupla</button>
                    <div class="col-md-12">
                        <h5>Duplas</h5>
                        <div class="row">
                            <div *ngFor="let it of dualItems; index as i" class="col-3 m-b-10">
                                <b ><a href="javascript:void(0)" (click)="restoreDualItem(i,it)">{{it.index1+1}} {{it.value1?'V':'F'}} {{it.index2+1}} {{it.value2?'V':'F'}}</a></b>
                            </div>
                        </div>                    </div>
                    <button (click)="setDualCorrelations()" class="btn btn-rounded waves-effect btn-primary m-b-20">Actualizar correlaciones</button><span *ngIf="loadingScales"><img width="20" src="assets/images/loading.gif" alt=""> Guardando...</span>

                </div>

            </div>

        </div>


<div class="card">
    <div class="card-body">
        <h4 class="card-title">Preguntas</h4>
        <div class="table-responsive">
            <table class="table table-bordered table-hover " >
                <thead>
                    <tr>
                        <th >#</th>
                        <th >Texto</th>
                        <th class="text-center">Editar/Borrar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let question of questions; index as i">
                        <td >{{i+1}}</td>
                        <td >{{question.text}}</td>
                        <td class="footable-visible footable-last-column text-center">
                            <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleEdit(question,i)" ><i class="fa fa-pencil" ></i></button>
                            <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id)" ><i class="fa fa-eraser" ></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>